module.exports = __webpack_public_path__ + "static/media/Lebanon.05425bb1.png";